import { LimitPageIndex } from 'types/interfaces/data';

export const womErrorStatusCode = 'error.balance.is.insufficient';

export const defaultQsSubscriptionsParams: LimitPageIndex = {
    limit: 20,
    pageIndex: 0
};
